// @ts-ignore
import { IconLayer } from "@deck.gl/layers";

export const MBPLayer = ({
    showMbp,
    mbp,
    onHoverPoi,
    handleClick,
    focusedItem,
    isGeoFocused,
    hoveredPresence,
}: any) => {
    if (!showMbp || !mbp?.length) return null;

    return new IconLayer({
        id: "mbp-layer",
        data: mbp,
        getPosition: (d: any) => [d.longitude, d.latitude],
        getIcon: (d: any) => {
            const iconSize = 100;
            return {
                url: d.icon,
                width: iconSize,
                height: iconSize,
                anchorX: iconSize / 2,
                anchorY: iconSize / 2
            };
        },
        sizeUnits: "pixels",
        // getSize: 27.17,
        pickable: true,
        pickingRadius: 10, // Increase picking radius to make markers easier to click
        getSize: (d: any) => {
            const isHovered = hoveredPresence?.unique_key === d.unique_key;
            const isFocused = focusedItem?.type === "mbp" && focusedItem?.data?.unique_key === d.unique_key;
            return (isHovered || isFocused) ? 30 : 27.17; // hovered or focused marker becomes larger
        },

        onHover: (info: any) => {
            const { object, pixel } = info;
            if (object) {
                onHoverPoi && !focusedItem.type && !isGeoFocused && onHoverPoi("mbp", object ?? null, pixel);
            } else {
                onHoverPoi && !isGeoFocused && onHoverPoi("mbp", null);
            }
        },
        onClick: (info: any) => {
            const { object, pixel } = info;
            // Allow clicks even when there's a focused item, to enable switching between markers
            handleClick && object && handleClick("mbp", object ?? null, pixel);
        },
        updateTriggers: {
            getSize: [focusedItem.type, focusedItem?.data?.unique_key, hoveredPresence?.unique_key],
        },
    });
};
